<div class="donwload-app-container" #storeBanner>
	<div class="text">
		<p class="primary">Looking for a Personalized Diet Plan?</p>
		<p class="secondary">Try the Hint app</p>
	</div>
	<div class="icons">
		<a
			(click)="clickStoreBanner()"
			href="https://play.google.com/store/apps/details?id=com.clearcals.hint"
			target="_blank"
			><img
				src="https://img.clearcals.com/site/images/hint/google_play.webp"
				alt="google play icon"
				height="80"
				width="258"
			/>
			<ul class="rating">
				<li *ngFor="let star of storeData.playStoreRatingFloor">
					<ic-icon [icon]="starIcon" class="checked"></ic-icon>
				</li>
				<li *ngIf="storeData.playStoreRatingDecimal">
					<ic-icon [icon]="starHalfIcon" class="checked"></ic-icon>
				</li>
				<span>352</span>
			</ul></a
		>
		<a
			(click)="clickStoreBanner()"
			href="https://apps.apple.com/in/app/hint-calorie-counter/id1632996742"
			target="_blank"
			><img
				src="https://img.clearcals.com/site/images/hint/apple_store.svg"
				alt="apple store icon"
				width="258"
				height="80"
			/>
			<ul class="rating left">
				<li *ngFor="let star of storeData.appStoreRatingFloor">
					<ic-icon [icon]="starIcon" class="checked"></ic-icon>
				</li>
				<li *ngIf="storeData.appStoreRatingDecimal">
					<ic-icon [icon]="starHalfIcon" class="checked"></ic-icon>
				</li>
				<span>71</span>
			</ul>
		</a>
	</div>
</div>
